import React, { useState, useEffect } from 'react'
import '../estilos/Contacto.css'

import axios from 'axios'
import Swal from 'sweetalert2'

function Contacto () {
  const values = { nombre: '', email: '', telefono: '', mensaje: '' }

  const [formValues, setFormValues] = useState(values)
  const [formErrors, setFormErrors] = useState({})
  const [isSubmit, setIsSubmit] = useState(false)
  const [response, setResponse] = useState(null)

  const handleChange = (e) => {
    const { name, value } = e.target
    if (name === 'telefono') {
      formValues.telefono = value.replace(/\D/g, '')
      setTimeout(() => {
        setFormValues(formValues)
      }, 0)
    }
    setFormValues({ ...formValues, [name]: value })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const err = validar(formValues)
    if (err === null) {
      axios
        .post(process.env.REACT_APP_API + 'Contacto/', formValues)
        .then(function (res) {
          res = res.data
          setResponse(res)
        })
    } else {
      setFormErrors(err)
      setTimeout(() => {
        setFormErrors({})
      }, 3000)
    }
    setIsSubmit(true)
  }
  const alerta = (response) => {
    if (response.status === false) {
      Swal
        .fire({
          title: 'Se ha presentado un error',
          text: response.msg,
          icon: 'error',
          confirmButtonText: 'Ok',
          allowEnterKey: false,
          allowEscapeKey: false,
          allowOutsideClick: false
        })
        .then((result) => {
          if (result.isConfirmed) {
            window.location.href = '/Contacto'
          }
        })
    } else if (response.status === true) {
      Swal
        .fire({
          title: 'Se ha enviado su mensaje',
          text: response.msg,
          icon: 'success',
          confirmButtonText: 'Ok',
          allowEnterKey: false,
          allowEscapeKey: false,
          allowOutsideClick: false
        })
        .then((result) => {
          if (result.isConfirmed) {
            window.location.href = '/Contacto '
          }
        })
    }
  }

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) { /* empty */ }
  }, [formErrors, isSubmit])

  const validar = (values) => {
    let isError = false
    const errors = {}
    const numero = values.telefono.length

    if (!values.nombre) {
      errors.nombre = 'Es necesario ingresar nombre'
      isError = true
    }
    if (!values.email) {
      errors.email = 'Es necesario ingresar correo'
      isError = true
    }
    if (!values.telefono) {
      errors.telefono = 'Es necesario ingresar telefono'
      isError = true
    } else if (numero < 10 || numero > 10) {
      errors.telefono = 'El numero debe de contener 10 digitos'
      isError = true
    }
    if (!values.mensaje) {
      errors.mensaje = 'Es necesario ingresar un mensaje'
      isError = true
    }
    return isError ? errors : null
  }

  return (
    <div className="contacto">
      <div className="izquierda">
        &nbsp;
        <h3> Datos del contacto</h3>
        &nbsp;
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1792.5979634955336!2d-103.42265805324425!3d25.570725475463593!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x868fda4f35cfed21%3A0xaaf2154ffefc72e0!2sUniclima!5e0!3m2!1ses!2smx!4v1690210544993!5m2!1ses!2smx"
          title="mapa"
          width="400"
          height="380"
          style={{ border: '0' }}
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
          className="mapa"
        ></iframe>
        <p className="direccion"> Blvd. Independencia No. 2447 Ote. </p>
        <p className="direccion"> Col. San Nuevo San Isidro C.P. 27100</p>
        <p className="direccion"> Torreón, Coah.</p>
      </div>
      <div className="derecha">
        <h1> Ponte en contacto </h1>
        <form id="form-contacto" onSubmit={handleSubmit}>
          <label htmlFor="nombre"> Nombre </label>
          <input
            name="nombre"
            placeholder="Ingresa tu nombre..."
            type="text"
            value={formValues.nombre}
            onChange={handleChange}
          ></input>
          <p className="error"> {formErrors.nombre} </p>

          <label htmlFor="email"> Email </label>
          <input
            name="email"
            placeholder="Ingresa tu correo electronico..."
            type="email"
            value={formValues.email}
            onChange={handleChange}
          ></input>
          <p className="error"> {formErrors.email} </p>

          <label htmlFor="telefono"> Telefono </label>
          <input
            name="telefono"
            placeholder="Ingresa tu numero..."
            type="text"
            value={formValues.telefono}
            onChange={handleChange}
          ></input>
          <p className="error"> {formErrors.telefono} </p>

          <label htmlFor="mensaje"> Mensaje </label>
          <textarea
            rows="6"
            placeholder="Ingresa tu mensaje..."
            name="mensaje"
            value={formValues.mensaje}
            onChange={handleChange}
          ></textarea>
          <p className="error"> {formErrors.mensaje} </p>
          <button type="submit"> Enviar </button>
          {response && alerta(response)}
        </form>
      </div>
      <div></div>
    </div>
  )
}

export default Contacto
